module.exports = __webpack_public_path__ + "img/baidu.bba6d3da.svg";